import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["row", "icon"]

  toggle(event) {
    const index = event.params.index
    const rows = this.rowTargets.filter(row => row.dataset.index === String(index))
    const icon = this.iconTargets.find(icon => icon.dataset.index === String(index))

    rows.forEach(row => {
      row.classList.toggle("hidden")
    })

    if (icon) {
      icon.classList.toggle("expanded")
    }
  }
}
